import React from 'react';
import { get } from '../../utils/api';
import styles from './Contracts.module.scss';

export const fetchContractsApi = async (
    url: string,
    setFn: (arg0: any) => void,
    loading: (arg0: any) => void
  ) => {
    const resp = await get(url);
    if (resp.ok) {
      setFn(await resp.json());
      loading(true);
    }
    return resp.ok;
  };

export const getTermsAndConditions = async (setFn: (arg: string | null) => void): Promise<Blob | null> => {
    try {
        const resp = await get('/contracts/terms_and_conditions');

        if (resp.ok) {
            const data = await resp.arrayBuffer();
            const blob = new Blob([data], { type: 'application/pdf' });
            return blob;
        } else {
            setFn('Unable to load Terms & Conditions PDF');
            return null;
        }
    } catch (error) {
        setFn('An error occurred while fetching Terms & Conditions.');
        return null; 
    }
};

export const LoadingContract = (
    <div className={styles.centeredMessageContainer}>
      <div>
        <h3><b>Loading contract, please wait...</b></h3>
        <span>If the issue still persists, please contact support on <b>012 804 6831</b>.</span>
      </div>
    </div>
  );

export const InvalidContract = (
  <div className={styles.centeredMessageContainer}>
    <div>
      <h3><b>Invalid Contract ID entered.</b></h3>
      <span>Please re-click the link on the email received.</span>
      <span>If the issue still persists, please contact support on <b>012 804 6831</b>.</span>
    </div>
  </div>
);
